module.exports = __webpack_public_path__ + "img/university-of-chicago-press-journals-logo.5b981fd2.png";